import React from 'react';
import VirtualList from 'rc-virtual-list';
import { PasscodesDeviceDto } from 'services/passcodes/passcodes.service';
import { useElementHeight } from 'tools/view-hooks/element-height-hook';

interface VirtualizedLockListProps {
    data: PasscodesDeviceDto[];
    renderRow: (lock: PasscodesDeviceDto) => React.ReactNode;
    itemHeight?: number;
}

// Lista virtualizada de cerraduras: mide su contenedor (flex:1) y le pasa el
// alto a rc-virtual-list, que monta solo las filas visibles. El look de la fila
// lo define renderRow (reusa la card del LockPicker). rc-virtual-list mide las
// alturas reales de las filas montadas; itemHeight es solo estimación inicial.
export const VirtualizedLockList: React.FC<VirtualizedLockListProps> = ({ data, renderRow, itemHeight = 64 }) => {
    const [containerRef, height] = useElementHeight();
    // T se infiere de `data` (PasscodesDeviceDto[]); callbacks tipados explícito
    // para evitar la sintaxis de genérico en JSX (frágil según el typing del export).
    return (
        <div ref={containerRef} className={'lock-picker-vlist'}>
            <VirtualList
                data={data}
                height={height}
                itemHeight={itemHeight}
                itemKey={(lock: PasscodesDeviceDto) => lock.id}
            >
                {(lock: PasscodesDeviceDto) => <div className={'lock-picker-vrow'}>{renderRow(lock)}</div>}
            </VirtualList>
        </div>
    );
};
